<template>
    <div class="wine-loading w-full flex flex-col items-center">
        <div class="wine-loadding__container w-full max-w-[35rem] h-[21.25rem] md:w-[31.25rem] overflow-hidden">
            <div ref="bottleContainer" class="wine-loading__bottles flex justify-start items-center gap-x-20 h-full" :style="`margin-left: -${mobileMinus}px;`">
                <div v-for="(i, index) in bottleOrder" :key="`bottle-${i}`" class="flex justify-center items-center w-[6.875rem] h-full flex-shrink-0">
                    <img :src="require(`@/static/images/bottles/bottle-${i}.svg`)" alt="Bouteille" :class="{ 'opacity-50': currentBottleIndex !== index }" class="max-w-full max-h-full transition-opacity duration-300" />
                </div>
            </div>
        </div>

        <div class="text-white text-center mt-16 px-6">
            <p class="lead">Recherche de la bouteille parfaite en cours...</p>
            <p class="body-2 mt-4">Notre sommelier sélectionne parmi nos 200 références</p>
        </div>
    </div>
</template>

<script setup>
    import { onMounted, ref, watch } from 'vue';
    import { gsap } from 'gsap';

    //// PROPS
    const props = defineProps({
        start: { type: Boolean, default: false },
    });

    //// DATA
    const bottleOrder = [1, 2, 1, 3, 1, 2, 1, 3];
    let currentBottleIndex = ref(1);
    let mobileMinus = ref(0);
    const bottleContainer = ref(null);

    watch(currentBottleIndex, (newValue) => {
        gsap.to(bottleContainer.value, {
            x: -((110 + 80) * (newValue - 1)),
            duration: 0.5,
            ease: 'power2.out',
        }).then(() => {
            setTimeout(() => {
                currentBottleIndex.value += 1;
            }, 1000);
        });
    });

    watch(
        () => props.start,
        (newValue) => {
            if (newValue) {
                currentBottleIndex.value += 1;
            }
        },
    );

    //// MOUNTED
    onMounted(() => {
        // Décalage mobile
        mobileMinus.value = window.innerWidth < 768 ? (500 - window.innerWidth) / 2 : 0;

        window.addEventListener('resize', () => {
            mobileMinus.value = window.innerWidth < 768 ? (500 - window.innerWidth) / 2 : 0;
        });
    });
</script>
